import React from 'react'

import { useAuth } from '../../hooks/context/UserAuthContext'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'

import { IconButton, Box } from '@mui/material'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import Logo from './Logo'

function HeaderLogo() {
  const auth = useAuth()
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  return (
    <Box pr={1} width={40}>
      <RouterLink to='/' aria-label='home'>
        <Logo height={32} />
      </RouterLink>
    </Box>
  )
}

export default HeaderLogo
